export var withDefaultProps = function (defaultProps, Component) {
    Component.defaultProps = defaultProps;
    return Component;
};
//# sourceMappingURL=index.js.map